module.exports = __webpack_public_path__ + "static/media/bulldog.9bafbe40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/bulldog.svg
// module id = 479
// module chunks = 0